import { useState } from "react";
import { SUGERIDOS, OPC } from "@/lib/api";
import { SelectField } from "@/components/Fields";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const OPCS = [
  { v: "APROBADO", cls: "bg-emerald-600 border-emerald-600 text-white" },
  { v: "NO APROBADO", cls: "bg-rose-600 border-rose-600 text-white" },
  { v: "MÁS ADELANTE", label: "Valorar más adelante", cls: "bg-amber-500 border-amber-500 text-white" },
  { v: "SIN CONTESTAR", cls: "bg-slate-600 border-slate-600 text-white" },
];
const BADGE = { APROBADO: "text-emerald-700", "NO APROBADO": "text-rose-700", "MÁS ADELANTE": "text-amber-700", "SIN CONTESTAR": "text-slate-500" };

export const respuestaGeneral = (ids, rt) => {
  const vals = ids.map((k) => rt[k] || "SIN CONTESTAR");
  if (vals.includes("APROBADO")) return "APROBADO";
  if (vals.length && !vals.includes("SIN CONTESTAR")) return "NO APROBADO";
  return "SIN CONTESTAR";
};

const Fila = ({ s, val, onPick }) => (
  <div data-testid={`resp-tto-${s.id}`} className="flex flex-wrap items-center gap-2 border-b border-slate-100 py-2">
    <span className="flex-1 min-w-[180px] text-sm text-slate-800">{s.label}</span>
    {OPCS.map((o) => (
      <button key={o.v} type="button" data-testid={`resp-tto-${s.id}-${o.v.replace(/\s|Á/g, "_").toLowerCase()}`} onClick={() => onPick(s.id, o.v)}
        className={`rounded-full border px-2.5 py-1 text-[11px] font-medium transition-colors ${val === o.v ? o.cls : "bg-white border-slate-200 text-slate-600 hover:border-slate-400"}`}>
        {o.label || o.v.charAt(0) + o.v.slice(1).toLowerCase()}
      </button>
    ))}
  </div>
);

export const RespuestaDesglose = ({ f, set }) => {
  const [open, setOpen] = useState(false);
  const sugs = SUGERIDOS.filter((s) => s.id !== "revision" && (f.tratamientos_sugeridos || []).includes(s.id));
  const ids = sugs.map((s) => s.id);
  const rt = f.respuestas_tto || {};
  const pick = (id, v) => {
    const nrt = { ...rt, [id]: v };
    set("respuestas_tto")(nrt);
    set("respuesta")(respuestaGeneral(ids, nrt));
    const val = (f.tratamientos_valorar || []).filter((x) => x !== id);
    set("tratamientos_valorar")(v === "MÁS ADELANTE" ? [...val, id] : val);
  };
  const resumen = sugs.filter((s) => rt[s.id] && rt[s.id] !== "SIN CONTESTAR");
  if (!sugs.length) return <SelectField label="Resp. tratamiento visual" value={f.respuesta} onChange={set("respuesta")} options={OPC.respuesta} testId="pf-respuesta" />;
  return (
    <div>
      <span className="block text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1">Resp. tratamiento visual</span>
      <button type="button" data-testid="pf-respuesta" onClick={() => setOpen(true)} title="Pulsa para apuntar la respuesta de cada tratamiento"
        className="flex h-9 w-full items-center justify-between rounded-md border border-slate-200 bg-white px-3 text-sm hover:border-slate-400">
        <span className={BADGE[f.respuesta] || "text-slate-400"}>{f.respuesta || "—"}</span>
        <span className="text-[11px] text-slate-400">{resumen.length}/{sugs.length} respondidos</span>
      </button>
      {resumen.length > 0 && (
        <ul className="mt-1 space-y-0.5" data-testid="pf-respuesta-resumen">
          {resumen.map((s) => <li key={s.id} className="text-[11px] leading-tight"><span className={`font-semibold ${BADGE[rt[s.id]]}`}>{rt[s.id] === "MÁS ADELANTE" ? "Más adelante" : rt[s.id].charAt(0) + rt[s.id].slice(1).toLowerCase()}</span> · <span className="text-slate-600">{s.label}</span></li>)}
        </ul>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl" data-testid="resp-tto-dialog">
          <DialogHeader><DialogTitle className="font-[Outfit]">¿Qué ha decidido la familia?</DialogTitle></DialogHeader>
          <p className="text-xs text-slate-500">Marca cada tratamiento. Al guardar se crean solo los <b>aprobados</b>; los de <b>«Valorar más adelante»</b> pasan a «A valorar después».</p>
          <div>{sugs.map((s) => <Fila key={s.id} s={s} val={rt[s.id] || "SIN CONTESTAR"} onPick={pick} />)}</div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-slate-600" data-testid="resp-tto-general">Respuesta general: <b className={BADGE[f.respuesta]}>{f.respuesta || "SIN CONTESTAR"}</b></span>
            <Button onClick={() => setOpen(false)} data-testid="resp-tto-close" className="bg-[#1E3A8A] hover:bg-[#1E40AF]">Listo</Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
